export interface IResults {
    id: string,
    title: string,
    [key: string]: string
}
export const mockResults = {
    'company':'Maxon',
    'part_number':'118891',
    'model_name':'EC 32 ‚àö√≤32 mm, brushless, 80 Watt, with Hall sensors',
     'nominal_voltage_in_volts':12.0,
    'thermal_time_constant_in_secs':14.8,
    'nominal_torque_in_mnm':44.6,
    'max_speed_in_rpm':25000.0,
    'speed_torque_gradient_in_rpm_mnm':35.8,
    'speed_constant_in_rpm_v':1280.0,
    'stall_torque_in_mnm':428.0,
    'price':424.41,
    'website':'https://www.maxongroup.com/maxon/view/product/motor/ecmotor/ec/ec32/118891',
    'description':'The electronically commutated EC motors are characterized especially by their favorable torque characteristics,high power, extremely broad speed range and, of course, by their unsurpassed service life.', 
    'chart_id':'64feb01a5bd18370db0d65eb',
    'diameter':'None',
    'length':'None',
    'torque_constant':'None',
    'image_url':'https://www.maxongroup.com/medias/sys_master/root/8845882228766/EC-32-118891-NEW.jpg'
    }